<template>
  <div class="main-content flex-1 bg-gray-100 mt-12 md:mt-10 pb-24 md:pb-5 overflow-y-auto ">
    <div class="bg-blue-800 p-2 shadow text-xl text-white">
      <h3 class="font-bold pl-2">Analytics</h3>
    </div>
    <alert variant="warning" v-if="isArtistInApproval" class="m-4">
      Your account is in approval stage. Our team is reviewing your artist application and will follow up with the next steps.
    </alert>
    <statistic-admin :is-loaded="!isArtist" v-if="!isArtist"></statistic-admin>
    <statistic-artist :is-loaded="isArtist" v-if="isArtist"></statistic-artist>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import clevertap from 'clevertap-web-sdk';
import Alert from '@/components/Layout/Alert';
import { StatisticAdmin, StatisticArtist } from '../components/Statistic';

export default {
  name: 'StatisticPage',
  data() {
    return {

    };
  },
  computed: {
    ...mapGetters('NotificationModule', ['isLoading', 'getStatus', 'getMessage', 'getErrorCode']),
    ...mapGetters('AuthModule', ['getUser', 'isArtist', 'isFinance', 'isArtistInApproval']),
  },
  mounted() {
    this.toggleDashboardProfile(false);
    if (this.isFinance) {
      this.$router.push({ name: 'PayoutList' });
    }
  },
  components: {
    StatisticAdmin,
    StatisticArtist,
    Alert,
  },
};
</script>
<style scoped>
  .count-listener{
    font-size: 36px;
  }
  .hc{
    width:100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/Statistic.vue